import { string, object } from "yup";

export const createForgotSchema = (t) => object().shape({
  identifiant: string().required(t('validation.identifiant_required')),
});

const forgotSchema = object().shape({
  identifiant: string().required("L'identifiant est obligatoire"),
});

export default forgotSchema;
